export enum BonusRuleBasisEnum {
    Default,
    Profit,
    Return,
};